// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../action-list';
import {getDefaultState as getClaimQuestionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-question';
import {getQuestionsRequired} from '../../../shared/repositories';

export const readQuestionsRequiredOptions = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getQuestionsRequired();

            const modifiedOptions = data.map(option => ({...getClaimQuestionDefaultState(), ...option}));

            dispatch({
                data: modifiedOptions,
                type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_QUESTIONS_REQUIRED_OPTIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/get-questions-required-options.js